import React from "react";
import ProcessSteps from "../../../Shared/ProcessSteps/ProcessSteps";

const semiPlannedStepsData = [
  {
    title: "기획 및 구성",
    details: [
      {
        subtitle: "출판사의 기획 역할",
        items: [
          "시장성 분석 : 타겟 독자층 및 경쟁도서 분석",
          "콘셉트 설정 : 도서의 방향성 및 포지셔닝",
          "구성 기획 : 목차 구성 및 내용 체계화",
          "디자인 기획 : 표지 및 본문 디자인 방향성",
        ],
      },
    ],
  },
  {
    title: "편집 및 감수",
    details: [
      {
        subtitle: "편집 과정에서 저작자의 역할",
        items: [
          "원고 제공 : 기본 원고 및 추가 자료 제공",
          "협의 참여 : 편집 방향 및 수정사항 협의",
          "검토 및 승인 : 편집 결과물 검토 및 최종 승인",
          "피드백 제공 : 독자 관점에서의 의견 제시",
        ],
      },
    ],
  },
  {
    title: "디자인 제작",
  },
  {
    title: "교정 및 검수",
  },
  {
    title: "인쇄 및 제본",
  },
];

const SemiPlannedProcess = () => {
  return <ProcessSteps title="반기획 출판 과정" steps={semiPlannedStepsData} />;
};

export default SemiPlannedProcess;
